module.exports = __webpack_public_path__ + "img/banner2.2eaf18d3.png";